import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {selectIsAnyConsumerProducts} from '@/state/selectors/consumer';
import {selectIsLoyaltyMember} from '@/state/selectors/consumerLoyalty';
import {isBannerEnabled} from '@/utils/bannerUtils';

export const useDynamicMobileHighlights = (highlights) => {
    const isAnyDeviceRegistered = useSelector(selectIsAnyConsumerProducts);
    const isLoyaltyMember = useSelector(selectIsLoyaltyMember);

    return useMemo(() => {
        if (!highlights?.length) return;

        return highlights.filter((highlight) =>
            isBannerEnabled(highlight?.banner, isAnyDeviceRegistered, isLoyaltyMember)
        );
    }, [highlights, isAnyDeviceRegistered, isLoyaltyMember]);
};
